export const PNT_LABEL = 'PNT';
export const PNT_EXPANSION = 'Paid — Awaiting Ticketing';
export const PNT_LONG = `${PNT_EXPANSION} (${PNT_LABEL})`;

/**
 * Canonical definition of PNT across the platform.
 *
 * PNT = Paid, Not Ticketed:
 * - The client has paid
 * - Tickets have not been issued yet
 * - Used to track and ensure timely ticketing/fulfillment
 */
export const PNT_DESCRIPTION =
  'Paid by client but not yet ticketed; used to track and ensure timely ticketing/fulfillment.';
